module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01-xlarge.f0fbfbd8.jpg";